import {} from './extentions'

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

export const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source)
  const destClone   = Array.from(destination)
  const [removed]   = sourceClone.splice(droppableSource.index, 1)

  destClone.splice(droppableDestination.index, 0, removed)

  const result = {};
  result[droppableSource.droppableId] = sourceClone
  result[droppableDestination.droppableId] = destClone

  return result
}

export const sanitize_path = (path, remove_end_slash) =>{
  if(!path || path === ''){
    return '/'
  }

  path = path.replace(/^\/+/g, '')
  path = path.replace(/([^:]\/)\/+/g, "$1")

  if(remove_end_slash && path.endsWith('/')){
    path = path.replace(/\/$/, "")
  }
  return path
}

export function isPromise(value) {
  if (value !== null && typeof value === 'object') {
    return value.promise && typeof value.promise.then === 'function';
  }
}

export const getCookie = name =>{
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export const get_previous_path = path =>{
  if(!path){
    return null;
  }

  if(!path.startsWith('/') && !path.startsWith('C:\\')){
    path = '/' + path
  }

  let slash = '/'
  if(path.startsWith('C:\\')){
    slash = '\\'
  }

  if(!path.endsWith(slash)){
    path = path + slash;
  }

  let splits = path.split(slash);
  splits[0] = slash;
  splits.pop();
  splits.pop();

  let previous_path = splits.join(slash);

  if(previous_path.startsWith(slash + slash)){
    previous_path = previous_path.substring(1);
  }

  if(previous_path === ''){
    previous_path = slash;
  }

  if(path === slash){
    previous_path = null;
  }

  return previous_path;
}

export const file_name = path => {
  if(!path){
    return null;
  }

  if(!path.endsWith('/')){
    path = path + '/';
  }

  let split = path.split('/');

  path = split[split.length - 2];
  return path
}

export const get_path_segments = (path, segments) => {
  path = '/' + (path || '').replace(/^\//, '');

  if(!segments){
    segments = [{ path: '/Cloud', name: 'Cloud' }];
  }

  var pathSplit = path === '' ? [] : path.split('/');
  pathSplit.filter(function(a) { return a !== ''; }).forEach(function(part, index) {
    var path_prefix = pathSplit.slice(0, index+1).join('/');
    segments.push({ path: path_prefix + '/' + part, name: part });
  });

  return segments;
}

export const split_host_and_port = (ip_and_port) => {

  if(!ip_and_port){
    return {host : '', port : ''};
  }
  var result = ip_and_port.split(":");

  return {host : result[0], port : result[1]};
}

export const copy_link = (text) => {

  if (!text) {
    return
  }

  try {
    var textArea              = document.createElement("textarea");
    textArea.style.position   = 'fixed';
    textArea.style.top        = 0;
    textArea.style.left       = 0;
    textArea.style.width      = '2em';
    textArea.style.height     = '2em';
    textArea.style.padding    = 0;
    textArea.style.border     = 'none';
    textArea.style.outline    = 'none';
    textArea.style.boxShadow  = 'none';
    textArea.style.background = 'transparent';
    textArea.value            = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
  } catch (e) {}

  document.body.removeChild(textArea);
}

export const sortBy = (key, reverse) =>{
  let moveSmaller = reverse ? 1 : -1
  let moveLarger = reverse ? -1 : 1
  return function(a, b) {
    if (a[key] < b[key]) {
      return moveSmaller
    }
    if (a[key] > b[key]) {
      return moveLarger
    }
    return 0;
  }
}

export const calculate_optimal_part_size = (size) =>{
  // max_part_count = 10000 → https://github.com/aws/aws-sdk-java/blob/master/aws-java-sdk-s3/src/main/java/com/amazonaws/services/s3/internal/Constants.java#L76
  // min_part_size  = 5242880

  let optimal_part_size = size/this.multipart_upload.max_part_count
  // round up so we don't push the upload over the maximum number of parts
  optimal_part_size = Math.ceil(optimal_part_size);
  return Math.max(optimal_part_size, this.multipart_upload.min_part_size)
}

export const is_supported_video_format = (filename='') =>
  ['mp4', 'webm', 'weba', 'ogv', 'mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'm4p', 'ogg', 'mpa']
    .indexOf((filename.split('.').pop()||'').toLowerCase()) >= 0

export const  isMacintosh = () => navigator.platform.indexOf('Mac') > -1

export const  isWindows = ()=> navigator.platform.indexOf('Win') > -1

export const parseUrl = url => {
    let parser = document.createElement('a')
    parser.href = url
    return parser
}

export const delay = ms => new Promise(res => setTimeout(res, ms))

export const to_hex = ArrayBuffer => {
    const byteArray = new Uint8Array(ArrayBuffer)
    const hexCodes = [...byteArray].map(value => {
        const hexCode = value.toString(16)
        return hexCode.padStart(2, '0')
    })
    return hexCodes.join('')
}

export const stream_to_array_buffer = (stream, part_size, start, end) =>
    new Promise((resolve, reject) => {
        const onData = data => {
            if (data.byteLength === 1) {
                return
            }
            arr.set(data, i)
            i += data.byteLength
        }

        const onEnd = err => {
            if (err) {
                reject(err)
            } else {
                resolve(arr)
            }
            cleanup()
        }

        const onClose = () => {
            resolve(arr)
            cleanup()
        }

        const cleanup = () => {
            arr = null
            stream.removeListener('data', onData)
            stream.removeListener('end', onEnd)
            stream.removeListener('error', onEnd)
            stream.removeListener('close', onClose)
        }

        // stream is empty or ended
        if (!stream.readable) {
            return resolve([])
        }

        let arr = new Uint8Array(Math.min(part_size, end - start)),
            i = 0
        stream.on('data', onData)
        stream.on('end', onEnd)
        stream.on('error', onEnd)
        stream.on('close', onClose)
    })

export default (size, nospace, one, places) =>{
    const sizes = [
        'Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB'
    ]

    /**
     Pretty print a size from bytes
     @method pretty
     @param {Number} size The number to pretty print
     @param {Boolean} [nospace=false] Don't print a space
     @param {Boolean} [one=false] Only print one character
     @param {Number} [places=1] Number of decimal places to return
     */

    if (typeof nospace === 'object') {
        const opts = nospace
        nospace = opts.nospace
        one = opts.one
        places = opts.places || 1
    } else {
        places = places || 1
    }

    let mysize

    sizes.forEach((unit, id) => {
        if (one) {
            unit = unit.slice(0, 1)
        }
        const s = Math.pow(1024, id)
        let fixed
        if (size >= s) {
            fixed = String((size / s).toFixed(places))
            if (fixed.indexOf('.0') === fixed.length - 2) {
                fixed = fixed.slice(0, -2)
            }
            mysize = fixed + (nospace ? '' : ' ') + unit
        }
    })
    if (!mysize) {
        let unit = (one ? sizes[0].slice(0, 1) : sizes[0])
        mysize = '0' + (nospace ? '' : ' ') + unit
    }
    return mysize
}
